import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Text,
} from '@chakra-ui/core';
import React from 'react';

const ResolutionDetailsModal = ({ isOpen, onOpen, onClose }) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="xl">
      <ModalOverlay>
        <ModalContent>
          <ModalHeader>Resolution Details</ModalHeader>
          <ModalCloseButton />
          <ModalBody bg="#eeeeee" mx={8} mb={8}>
            <Text fontSize="sm">
              The winner of the 2020 general presidential election shall be the
              nominee of the party identified in the question. For purposes of
              this market, a party's presidential candidate as of 12:01 a.m.
              (ET) on November 3, 2020 shall be considered that party's nominee.
            </Text>
            <br />
            <Text fontSize="sm">
              A nominee that receives at least 270 votes in the Electoral
              College shall be considered the winner. In the event that no
              nominee receives 270 votes, the House of Representatives will
              decide the winner. In the event of further indecision or tie, it
              will be the nominee determined to be the winner under the US
              Constitution.
            </Text>
            <br />
            <Text fontSize="sm">
              In the event of ambiguity in terms of the bet outcome,
              Atomic.Finance reserves the right to wait for further official,
              party, judicial or other relevant announcements, reports or
              decisions to resolve any ambiguity or uncertainty before the
              market is settled.
            </Text>
            <br />
            <Text fontSize="sm">
              On February 1, 2021, if there exists further indecision, both
              betting counterparties shall be refunded their bet amounts.Both
              betting counterparties shall also be refunded in the event that a
              candidate emerges victorious who is affiliated with neither the
              Republican and Democratic Parties.
            </Text>
          </ModalBody>
        </ModalContent>
      </ModalOverlay>
    </Modal>
  );
};

export default ResolutionDetailsModal;
